// SCREEN_LIVE (配信中) で使うAPI

// GET /vtubers/live-now?tags=genre_game,talk_casual,day_friday
// タグは優先順位順(最大3件)に渡す。スコアリング・並び替えはサーバー側で行う。
export const getLiveNow = async (tags = []) => {
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/live?tags=${tags.join(",")}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status}`);
  }

  const data = await response.json();

  return data.items ?? data;
};
